"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>VerificationCode
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const OtpForm_styles_js_namespaceObject = require("../OtpForm/OtpForm.styles.js");
const OtpContext_js_namespaceObject = require("../../context/OtpContext.js");
const ChatbotDataContext_js_namespaceObject = require("../../context/ChatbotDataContext.js");
const external_ResentButton_js_namespaceObject = require("./ResentButton.js");
var external_ResentButton_js_default = /*#__PURE__*/ __webpack_require__.n(external_ResentButton_js_namespaceObject);
const VerificationCode_VerificationCode = ()=>{
    const messageEndRef = (0, external_react_namespaceObject.useRef)(null);
    const errorMessage = "I\u2019m\xa0having\xa0some trouble\xa0accessing your trip information. ";
    const [showVerificationError, setShowVerificationError] = (0, external_react_namespaceObject.useState)(false);
    const [validOtpCode, setValidOtpCode] = (0, external_react_namespaceObject.useState)(false);
    const [smsCode, setSmsCode] = (0, external_react_namespaceObject.useState)();
    const { verificationApiFunction, setOtpRequestErrorMsg, handleOtpSubmit, resendInProgress } = (0, OtpContext_js_namespaceObject.useOtpContext)();
    const [otpValidationInProgress, setOtpValidationInProgress] = (0, external_react_namespaceObject.useState)(false);
    const { setAccountLessAccessToken } = (0, external_react_namespaceObject.useContext)(ChatbotDataContext_js_namespaceObject.ChatbotDataContext);
    (0, external_react_namespaceObject.useEffect)(()=>{
        messageEndRef.current?.scrollIntoView({
            behavior: 'smooth'
        });
    }, []);
    const isSmsCodeValidated = (0, external_react_namespaceObject.useMemo)(()=>smsCode && /^\d{6}$/.test(String(smsCode)), [
        smsCode
    ]);
    const disableButton = (0, external_react_namespaceObject.useMemo)(()=>!(smsCode && isSmsCodeValidated), [
        smsCode,
        isSmsCodeValidated
    ]);
    function handleSmsCodeChange(e) {
        const value = e.currentTarget.value;
        setShowVerificationError(false);
        if (/^\d*$/.test(value) && value.length <= 6) setSmsCode(value);
    }
    async function submitFormHandler(e) {
        e.preventDefault();
        setOtpRequestErrorMsg('');
        setOtpValidationInProgress(true);
        try {
            const verificationResult = await verificationApiFunction(smsCode);
            if (verificationResult.success) {
                setValidOtpCode(true);
                setAccountLessAccessToken(verificationResult.token);
                handleOtpSubmit(verificationResult.token);
            } else setShowVerificationError(true);
        } catch (e) {
            setOtpRequestErrorMsg(errorMessage);
        } finally{
            setOtpValidationInProgress(false);
        }
    }
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
        children: [
            otpValidationInProgress ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Spinner, {}) : validOtpCode ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                fontWeight: 'bold',
                children: "Success!"
            }) : resendInProgress ? null : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Box, {
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Flex, {
                        flexDirection: 'column',
                        pb: 2,
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Box, {
                            children: [
                                showVerificationError ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(OtpForm_styles_js_namespaceObject.ErrorToolTip, {
                                    id: "otp-verification-error",
                                    right: true,
                                    top: true,
                                    color: "error",
                                    children: "It looks like that code isn\u2019t working. It may have expired or been entered incorrectly. Please try again."
                                }) : null,
                                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.FormField, {
                                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(OtpForm_styles_js_namespaceObject.FormInput, {
                                        id: "code",
                                        name: "phone",
                                        type: "text",
                                        inputMode: "numeric",
                                        pattern: "[0-9]{6}",
                                        maxLength: 6,
                                        placeholder: '6-digit code \u207A',
                                        onChange: handleSmsCodeChange,
                                        value: smsCode
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Button, {
                            disabled: disableButton,
                            onClick: submitFormHandler,
                            children: "Confirm"
                        })
                    })
                ]
            }),
            !otpValidationInProgress && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ResentButton_js_default(), {
                validOtpCode: validOtpCode
            })
        ]
    });
};
const VerificationCode = VerificationCode_VerificationCode;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
